exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.menu-item > a[data-v-d48373ba], .menu-item > a[data-v-d48373ba]:hover, .menu-item > a[data-v-d48373ba]:active, .menu-item > a[data-v-d48373ba]:focus {\n  background: transparent;\n}\n\n/* purgecss end ignore */\n", ""]);
